// Keep the established names because they are sent to the translation model.
// Mandarin and Cantonese are intentionally separate choices.
export const LANGUAGES = [
  'Arabic',
  'Cantonese',
  'English',
  'Farsi',
  'French',
  'German',
  'Hebrew',
  'Hindi',
  'Italian',
  'Japanese',
  'Korean',
  'Mandarin',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Spanish',
  'Swahili',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
];

export const RTL_LANGUAGES = new Set(['arabic', 'farsi', 'hebrew']);

export const isEnglish = (language = '') =>
  language.trim().toLowerCase() === 'english' || language.trim().toLowerCase() === 'en';

export const isRTL = (language = '') => RTL_LANGUAGES.has(language.trim().toLowerCase());

export const displayLanguage = (language = '') => (isEnglish(language) ? 'English' : language);
